import { useState } from 'react';

const NAV_LINKS = [
  { href: '#feed', label: '今日快讯' },
  { href: '#entries', label: '导航入口' },
  { href: '#collections', label: '热门合集' },
  { href: '#index', label: '人物索引' },
  { href: '#events', label: '事件脉络' },
  { href: '#archive', label: '归档索引' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between gap-3 py-3 md:py-4">
          <div className="hidden md:flex flex-col text-[11px] leading-snug text-foreground-600">
            <span className="font-label tracking-wide">2026年9月12日 星期六</span>
            <span className="font-label tracking-[0.2em] text-foreground-500">总第 092 期</span>
          </div>

          <h1 className="flex items-baseline gap-2 md:gap-3">
            <a href="#top" className="font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              17.cn
            </a>
            <span className="hidden sm:inline-block h-4 w-px bg-background-300" />
            <span className="hidden sm:inline text-xs md:text-sm font-label tracking-[0.3em] text-primary-600">
              黑料导航
            </span>
          </h1>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#download"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 md:px-4 py-2 text-xs md:text-sm font-label text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-2-line" />
              </span>
              整期下载
            </a>
            <button
              type="button"
              aria-label="展开导航菜单"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
            </button>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-1 border-t border-background-200 py-2">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-1.5 text-sm font-label text-foreground-700 rounded-md transition-colors hover:bg-background-100 hover:text-primary-600 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <span className="ml-auto text-xs font-label tracking-[0.25em] text-foreground-500">
            持续整理 · 每日更新
          </span>
        </nav>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-1">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block px-2 py-2.5 text-sm font-label text-foreground-800 border-b border-background-200 last:border-0 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}